<template>
    <button class="pdf-btn" @click="generatePDF">
        <svg class="pdf-print-icon" fill="white"  viewBox="-10 0 43 35" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.656 6.938l-0.344 2.688h11.781l-0.344-2.688c0-0.813-0.656-1.438-1.469-1.438h-8.188c-0.813 0-1.438 0.625-1.438 1.438zM1.438 11.094h19.531c0.813 0 1.438 0.625 1.438 1.438v8.563c0 0.813-0.625 1.438-1.438 1.438h-2.656v3.969h-14.219v-3.969h-2.656c-0.813 0-1.438-0.625-1.438-1.438v-8.563c0-0.813 0.625-1.438 1.438-1.438zM16.875 25.063v-9.281h-11.344v9.281h11.344zM15.188 18.469h-8.125c-0.188 0-0.344-0.188-0.344-0.375v-0.438c0-0.188 0.156-0.344 0.344-0.344h8.125c0.188 0 0.375 0.156 0.375 0.344v0.438c0 0.188-0.188 0.375-0.375 0.375zM15.188 21.063h-8.125c-0.188 0-0.344-0.188-0.344-0.375v-0.438c0-0.188 0.156-0.344 0.344-0.344h8.125c0.188 0 0.375 0.156 0.375 0.344v0.438c0 0.188-0.188 0.375-0.375 0.375zM15.188 23.656h-8.125c-0.188 0-0.344-0.188-0.344-0.375v-0.438c0-0.188 0.156-0.344 0.344-0.344h8.125c0.188 0 0.375 0.156 0.375 0.344v0.438c0 0.188-0.188 0.375-0.375 0.375z"></path>
        </svg>
    </button>
</template>

<script>
import html2pdf  from 'html2pdf.js'

export default {
  props: {
    hotel: {
        type: Object,
        required: true
    }
  },

  data(){
    return {
        options: {
            margin: 5,
            filename: 'hotel-info.pdf',
            image: { type: 'webp', quality: 1 },
            pagebreak: { mode: ['avoid-all'] },
            html2canvas: { useCORS: true, scale: 2 },
        }
      }
  },

  methods: {
    async generatePDF(){
      const descriptions = this.hotel.moreInfo;
      const data = this.hotel.data;
      const images = this.hotel.images;

      if(!data && !descriptions.length) return

      const name = this.getHotelName(data, true) ?? ""
      const geography = {
        city:  this.getHotelCity(data, true),
        country: this.getHotelCountry(data, true)
      }
      const address = [geography.city, geography.country].filter(el => el).join(', ')

      const contentImages = images?.length ? 
          `
           <div class="pdf-pictures">
              <div class="pdf-image-main" style="background-image: url(${images[0].replace("small160x90", "big")})"</div>
           </div>
            ` 
        : ""
        
      const contentHeader = `
          <div class="pdf-header">
              <h1 class="pdf-header-title">Информация об отеле</h1>
              <h2 class="pdf-header-name">${name}</h2>
              <p class="pdf-header-geography"> ${address} </p>
              ${contentImages}
          </div>  
        `

       const contentBody = descriptions.map(el => {
          const title = el.title ? el.title.replace(/(<([^>]+)>)/ig, '') : ""
          return `<div class="pdf-description-block"> <h3>${title}</h3> <p> ${el.value || address} </p> </div> `
       })

       const content = [contentHeader, ...contentBody].join('')

       await html2pdf().set(this.options).from(content).save();
    },

    getHotelName(data) {
      const hotel = this.getHotelFromServices(data)
      return hotel ? hotel.Hotel.Value : data.hotelName;
    },

    getHotelCity(data) {
      const hotel = this.getHotelFromServices(data)
      return hotel ? hotel.City.Value : data.hotelCity;
    },

    getHotelCountry(data) {
      const hotel = this.getHotelFromServices(data)
      return hotel ? hotel.Country.Value : data.hotelCountry;
    },

    getHotelFromServices(data){
      if(!data.Services?.length) return
      return data.Services ? data.Services.find(x => x.SvKey === 3) : null;
    }
  }
}
</script>

<style>
.pdf-header {
  margin-bottom: 10px;
}

.pdf-header-title {
  margin-bottom: 20px;
  text-align: center;
}

.pdf-header-name {
  margin-bottom: 10px;
}

.pdf-header-geography {
  font-size: 14px;
  color: #979797;
}

.pdf-pictures {
  height: 400px;
  width: 100%;
  max-width: 700px;
  margin: 20px auto;
}

.pdf-image-main{
  width: 100%;
  height: 100%;
  background-size: 102%;
  background-repeat: no-repeat;
  background-position: 50%;
  border-radius: 6px;
}

.pdf-description-block {
  margin-bottom: 20px;
}
</style>

<style scoped>
.pdf-wrapper {
  margin-bottom: 40px;
}

.pdf-print-icon {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.pdf-btn {
  position: relative;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 4px;
  background: white;
  color: #fff;
  background-color: #428bca;
  border-color: #357ebd;
  height: 40px;
  width: 40px;
}
</style>